import {
  CREATE,
  CREATE_CUSTOM
} from '@hobs/constants/additionalServiceRequest';
import { actionCreator } from './utils/utils';

export const createAdditionalServiceRequest = body =>
  actionCreator('Additional', CREATE, {
    body: body,
    method: 'POST'
  });

export const createCustomAdditionalServiceRequest = body =>
  actionCreator('Additional/Custom', CREATE_CUSTOM, {
    body: body,
    method: 'POST'
  });
